module.exports = __webpack_public_path__ + "43c2dba189ee1a6e4a3a8f6a7654660e.svg";